import styles from "./AlertUser.module.css"
import { TriangleAlert } from "lucide-react"
import { toast } from "react-toastify";
import { useState } from "react";

function AlertUser({ setIsOpen, entity, func }) {
    return (
        <div className={styles.container}>
            <div className={styles.form}>
                <div className={styles.containerOne}>
                    <p>Os Registro de ID {entity.id} será {entity.emailConfirmed ? "Desativado" : "Ativado"}. Tem certeza que deseja prosseguir com essa ação?</p>
                </div>
                <div className={styles.containerButtons}>
                    <button className={styles.nao} onClick={() => setIsOpen(false)}>Não</button>
                    <button className={styles.sim} onClick={async () => {

                        const payload = {
                            Id: entity.id,
                            Name: entity.name,
                            UserName: entity.userName,
                            Departamento: entity.departamento,
                            EmailConfirmed: !entity.emailConfirmed,
                            Cargo: entity.cargo,
                        }


                        await func(payload)
                            .then(() => {
                                setIsOpen(false);
                                toast.success(`Registro ${entity.id} atualizado!`);
                            })
                            .catch((error) => {
                                if (error.response.status === 401) {
                                    return toast.error("Não autorizado!");
                                } else if (error.response.status != 200) {
                                    return toast.error("Erro! Verificar com suporte");
                                }
                            })
                    }}>
                        Sim
                    </button>
                </div>
            </div>
        </div>
    )
}

export default AlertUser;